import { routingRules } from "./routing";
import { KM_FUNERAL_CLAIM_ROUTING_SET_VALUE } from "../../../actions/kaMetlhaFuneralClaim/routing";
import { CLAIMENT_DETAILS_FORM_SET_VALUE, CLAIMENT_DETAILS_SET_VALUE } from "../../../actions/kaMetlhaFuneralClaim/claimentDetails";
import { claimentDetailsRules } from "./claimentDetails";
import { DECEASED_DETAILS_SET_VALUE } from "../../../actions/kaMetlhaFuneralClaim/deceasedDetails";
import { deceasedDetailsRules } from "./deceasedDetails";
import { uploadDocumentsRules } from "./uploadDocuments";
import { UPLOAD_DOCUMENTS_SET_VALUE } from "../../../actions/kaMetlhaFuneralClaim/uploadDocuments";


export const kaMetlhaFuneralClaimRules = (store, next, action) => {
  // //Personal Details
  if (action.type.startsWith(CLAIMENT_DETAILS_SET_VALUE) ){
        return claimentDetailsRules(store, next, action);}
    // Upload Documents rules
    if (action.type.startsWith(UPLOAD_DOCUMENTS_SET_VALUE))
      return uploadDocumentsRules(store, next, action);
    // Deceased detail rules
    if (action.type.startsWith(DECEASED_DETAILS_SET_VALUE))
      return deceasedDetailsRules(store, next, action);
    // Trigger routing transitions
   if (action.type.startsWith(KM_FUNERAL_CLAIM_ROUTING_SET_VALUE))
        return routingRules(store, next, action);

  return null;
};
